import { defineComponent as _defineComponent } from 'vue'
import ThankYouModal from '@/components/Modals/Vacancy/ThankYouModal.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ThankYouModalContainer',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { ThankYouModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})